<template>
    <div class="card">
        <div class="card-header bg-primary font-weight-bold text-white d-flex align-items-center">
            Pengaturan Sertifikat
            <Button class="btn btn-md btn-dark px-4 py-2 ml-auto text-white" @click="$router.go(-1)">Kembali </Button>
        </div>
        <div class="card-body">
            <div class="form-row">
                <div class="form-group col-md-12">
                    <center>
                    <img
                        :src="lihat_foto  ? lihat_foto : '/img/placeholder-image.png'"
                        style="height:220px"
                        class=" img img-responsive elevation-2 border"
                    />
                    <br>
                    <span class="text-danger">*Format Gambar(PNG), Ukuran 500 x 850</span>

                    <div class="mt-2">
                        <div class="upload-btn-wrapper">
                            <button type="button" class="btn-upload" @click="chooseFiles()"> Unggah Flyer</button>
                            <center>
                                <input type="file" id="fileUpload"  name="myfile" @change="uploadFlyer($event)" ref="refFlyer" />
                            </center>
                        </div>
                    </div>
                    </center>
                </div>
                <div class="form-group col-md-12">
                    <label>Text Line 1 <small>(Peserta)</small></label>
                    <input type="text" class="form-control" v-model="formData.textLineSatu" value="Institut Akuntan Publik Indonesia">
                </div>
                <div class="form-group col-md-12">
                    <label>Text Line 2 <small>(Peserta)</small></label>
                    <input type="text" class="form-control" v-model="formData.textLineDua" value="Institut Akuntan Publik Indonesia">
                </div>
                <div class="form-group col-md-12">
                    <label>Text Line 3 <small>(Peserta)</small></label>
                    <input type="text" class="form-control" v-model="formData.textLineTujuh" value="Institut Akuntan Publik Indonesia">
                </div>
                <div class="form-group col-md-12">
                    <label>Text Line 1 <small>(Instruktur)</small></label>
                    <input type="text" class="form-control" v-model="formData.textLineTiga" value="Institut Akuntan Publik Indonesia">
                </div>
                <div class="form-group col-md-12">
                    <label>Text Line 2 <small>(Instruktur)</small></label>
                    <input type="text" class="form-control" v-model="formData.textLineEmpat" value="Institut Akuntan Publik Indonesia">
                </div>
                <div class="form-group col-md-12">
                    <label>Text Line 3 <small>(Instruktur)</small></label>
                    <input type="text" class="form-control" v-model="formData.textLineDelapan" value="Institut Akuntan Publik Indonesia">
                </div>
                <div class="form-group col-md-12">
                    <label>Text Line 1 <small>(Moderator)</small></label>
                    <input type="text" class="form-control" v-model="formData.textLineLima" value="Institut Akuntan Publik Indonesia">
                </div>
                <div class="form-group col-md-12">
                    <label>Text Line 2 <small>(Moderator)</small></label>
                    <input type="text" class="form-control" v-model="formData.textLineEnam" value="Institut Akuntan Publik Indonesia">
                </div>
                <div class="form-group col-md-12">
                    <label>Text Line 3 <small>(Moderator)</small></label>
                    <input type="text" class="form-control" v-model="formData.textLineSembilan" value="Institut Akuntan Publik Indonesia">
                </div>
                <div class="form-group col-md-12">
                    <label>Tanggal Pelatihan</label>
                    <input type="text" class="form-control" v-model="formData.tanggalPelatihan">
                </div>
            </div>
        </div>
         <div class="card-footer bg-white border-0 ml-auto mb-5 mr-3 float-right">
            <Button class="btn btn-md btn-success px-4 py-2"  type="submit" color="success" @click="postData">Simpan</Button>
        </div>
    </div>
</template>
<script>

import { AlertUtils } from "@/mixins/AlertUtils"
import { UploadImage } from '@/mixins/UploadImage'
import BaseUrl from "@/services/base-url";
import WorkshopService from "@/services/pelatihan/workshop.service";

export default {
    mixins:[AlertUtils, UploadImage],
    data() {
        return {
            lihat_foto: null,
            baseUrl : '',
            formData: {
                file: '',
                textLineSatu: '',
                textLineDua: '',
                textLineTiga: '',
                textLineEmpat: '',
                textLineLima: '',
                textLineEnam: '',
                textLineTujuh: '',
                textLineDelapan: '',
                textLineSembilan: '',
                tanggalPelatihan: '',
                fileNameCertificate: '',
                backgroundSertifikat: ''
            }
        }
    },
    mounted() {
        this.baseUrl = BaseUrl();
        this.getData();
    },
    methods : {
        chooseFiles: function() {
            document.getElementById("fileUpload").click()
        },
        getData() {
            WorkshopService.getDetailPengaturanSertifikat(this.$route.params.id)
            .then(response => {
                this.formData = response.data.singleData
                let routeData = this.baseUrl  + "/files?filename=" + response.data.singleData.background + "&path=pelatihan@backgroundsertifikat";
                this.lihat_foto = routeData;
            }).catch(error => {

            })
            
        },
        postData() {
            var formData = this.formData;
            var vm = this;
            if (typeof formData.flyer === "string") {
                delete formData.flyer
            }
            formData.id_workshop_pelatihan = this.$route.params.id

            // updatePengaturanSertifikat
            let loader = this.$loading.show({
                container: false ? null : this.$refs.formContainer,
                canCancel: true,
                onCancel: this.onCancel
            });
            WorkshopService.updatePengaturanSertifikat(formData)
            .then(() => {
                loader.hide();
                vm.alertSuccess();
                this.$router.go(-1);

            }).catch(error => {
                loader.hide();
            })
        }
    }
}
</script>

<style>
.btn-upload {
  width:50%;

  border: 2px solid gray;
  color: gray;
  background-color: white;
  padding: 5px 15px;
  border-radius: 8px;
  font-size: 15px;
  font-weight: bold;
}
.upload-btn-wrapper {
  width:100%;
  position: relative;
  overflow: hidden;
  display: inline-block;
}

.upload-btn-wrapper input[type="file"] {
  font-size: 30px;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
}
</style>